import { render, staticRenderFns } from "./PremiumForm.vue?vue&type=template&id=4ec97efb&"
import script from "./PremiumForm.vue?vue&type=script&lang=js&"
export * from "./PremiumForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports